/* DAILYACTIVITY */
export const DAILYACTIVITY_LIST = 'DAILYACTIVITY_LIST';
export const DAILYACTIVITY_LIST_SUCCESS = 'DAILYACTIVITY_LIST_SUCCESS';
export const DAILYACTIVITY_LIST_FAILED = 'DAILYACTIVITY_LIST_FAILED';

export const DAILYACTIVITY_ADD = 'DAILYACTIVITY_ADD';
export const DAILYACTIVITY_ADD_SUCCESS = 'DAILYACTIVITY_ADD_SUCCESS';
export const DAILYACTIVITY_ADD_FAILED = 'DAILYACTIVITY_ADD_FAILED';

export const DAILYJOBDES_ADD = 'DAILYJOBDES_ADD';
export const DAILYJOBDES_ADD_SUCCESS = 'DAILYJOBDES_ADD_SUCCESS';
export const DAILYJOBDES_ADD_FAILED = 'DAILYJOBDES_ADD_FAILED';

export const DAILYACTIVITY_UPDATE = 'DAILYACTIVITY_UPDATE';
export const DAILYACTIVITY_UPDATE_SUCCESS = 'DAILYACTIVITY_UPDATE_SUCCESS';
export const DAILYACTIVITY_UPDATE_FAILED = 'DAILYACTIVITY_UPDATE_FAILED';

export const DAILYACTIVITY_DELETE = 'DAILYACTIVITY_DELETE';
export const DAILYACTIVITY_DELETE_SUCCESS = 'DAILYACTIVITY_DELETE_SUCCESS';
export const DAILYACTIVITY_DELETE_FAILED = 'DAILYACTIVITYADD_DELETE_FAILED';
